import Domain from 'helpers/Domain';

const CSID_ID = {
    LOCAL_LIVE: 'streaming_paramountplus_us_desktop_web_live',
    LOCAL_VOD: 'streaming_paramountplus_us_desktop_web_vod',
    INTL_LIVE: 'streaming_paramountplus_{region}_desktop_web_live',
    INTL_VOD: 'streaming_paramountplus_{region}_desktop_web_vod',
};

export const getCSID = (isLiveStreaming, region, vendorCode = null) => {
    let csid = '';
    if (Domain.isDomestic() && isLiveStreaming) {
        csid = CSID_ID.LOCAL_LIVE;
    } else if (Domain.isDomestic() && !isLiveStreaming) {
        csid = CSID_ID.LOCAL_VOD;
    } else if (Domain.isInternational() && isLiveStreaming) {
        csid = CSID_ID.INTL_LIVE.replace('{region}', region?.toLowerCase());
    } else if (Domain.isInternational() && !isLiveStreaming) {
        csid = CSID_ID.INTL_VOD.replace('{region}', region?.toLowerCase());
    }
    if (typeof vendorCode == 'string') {
        csid = `${csid}_${vendorCode.toLowerCase()}`;
    }
    return csid;
};

export const getVideoAdLanguageSelection = () => {
    let language = '';
    const storageSmartTagData = localStorage.getItem('smart-tag-pplus');
    if (storageSmartTagData) {
        try {
            const smartTagData = JSON.parse(storageSmartTagData);
            language = smartTagData?.audioTrack?.language || '';
            if (language.length > 2) {
                language = language.substring(0, 2);
            }
        } catch (error) {
            console.err('SMARTTAG ADAPTER - LANGUAGE SELECTION ERROR', error);
        }
    }
    return language;
};
